
"use strict"; // jshint ignore:line

import {
	Math as THREEMath,
	GridHelper,
	Object3D,
	Vector2,
	Vector3,
	Euler,
	SpotLight,
	Raycaster,
	Mesh,
	MeshBasicMaterial,
	PerspectiveCamera,
	OrthographicCamera,
	WireframeGeometry,
	CylinderGeometry,
	Box3
} from '../../../src/js/three.module.js';

import { getIntersects } from '../../utils/intersections/get-intersects.js';
import { adjustPointToHeight } from '../../utils/adjust-point-to-height.js';

import { restrictPositionIntoBoundingBox } from '../../utils/restrict-position-into-bounding-box.js';

import Spherical360SetupService from '../services/Spherical360SetupService.js';



import { Box3Helper } from '../../utils/box3-helper.js'


const PLAYER_MAX_WALK_ITERATIONS = 200;
const PLAYER_MAX_TURN_ITERATIONS = 50;

class PlayerAsClass {


	$cameraControlsDisabled = false;
	$cameraZoomControlsDisabled = true;
	$keyboardControlsDisabled = false;

	constructor( opts ) {}
}

export default function Player( opts ){

	Object.assign( this, new PlayerAsClass( opts ));

	this.opts = opts = opts || {};

	this.pos  = opts.pos ? (Array.isArray( opts.pos ) ? new Vector3(opts.pos[0]||0, opts.pos[1]||0, opts.pos[2]||0) : opts.pos ) : new Vector3(0, 0, 0);
	this.av   = opts.av  || 0;
	this.ah   = opts.ah  || 0;

	this.jumpyplus  = opts.jumpyplus  || -0.2;
	this.g_yplus    = opts.g_yplus    || 0.03;
	this.height     = opts.height     || 1.50;
	this.radius     = opts.radius     || 0.1;
	this.footHeight = opts.footHeight || 0.4;

	this.av_plus    = 0;
	this.yplus      = 0;
	this.jumpable   = false;

	opts.light = opts.light || {
		intensity : 0.1,
		angle     : Math.PI / 2
	};

	if ( typeof opts.light != "undefined" ) {
		this.light = new SpotLight(
			typeof opts.light.color     === "undefined" ? 0xffffff  : opts.light.color,
			typeof opts.light.intensity === "undefined" ? 0.2       : opts.light.intensity,
			typeof opts.light.distance  === "undefined" ? undefined : opts.light.distance,
			typeof opts.light.angle     === "undefined" ? undefined : opts.light.angle
		);
		this.light.castShadow = true;
	}

	var ratio = window.innerWidth / window.innerHeight;
	this.cameras = {};
	this.cameras.head = new PerspectiveCamera( 60, ratio, 0.01, 10000 );
	this.cameras.bird = new PerspectiveCamera( 60, ratio, 10,  10000 ); /*new THREE.OrthographicCamera( -10*ratio, 10*ratio, 10, -10, 10, 10000 );*/
	this.cameras.bird.userData.ratio  = ratio;
	this.cameras.bird.userData.zspeed = 2;
	this.cameras.bird.$origo     = new Vector3().copy( this.cameras.bird.position );
	this.cameras.bird.$direction = new Vector3();
	this.setCamera( "head" );

	this.headPos = this.cameras.head.position.set( this.pos.x, this.pos.y + this.height, this.pos.z );

	this.keys = { left : 0, right : 0, up : 0, down : 0, pgup : 0, pgdown : 0 };

	this.turnFactor = opts.turnFactor;

	this.fspeed = opts.fspeed || 2.5;
	this.bspeed = opts.bspeed || 0.2;
	this.yspeed = opts.yspeed || 0.2;

	this.footRaycaster  = new Raycaster();
	this.footRaycaster.ray.direction.set( 0, -0.1, 0 );

	this.obj = new Mesh( new WireframeGeometry( new CylinderGeometry( this.radius, this.radius, this.height, 32 ) ), new MeshBasicMaterial( {color: 0xffff00} ) );

	this.lookAtObj = new Object3D();

	this.obj.material.depthTest = false;
	this.obj.material.opacity = 0.25;
	this.obj.material.transparent = true;

	// this.controls = new THREE.PointerLockControls( this.camera );

	this.opts.disableWalls          = !!this.opts.disableWalls;
	this.opts.disableGravity        = !!this.opts.disableGravity;
	this.opts.disableVerticalCamera = !!this.opts.disableVerticalCamera;
	this.opts.disableJumping        = !!this.opts.disableJumping;
	this.opts.cameraSlerp           = this.opts.cameraSlerp != null ? parseFloat( this.opts.cameraSlerp ) : 1;
	this.opts.cameraSlerp           = Math.min( 1, Math.max( 0, this.opts.cameraSlerp ));


	this.movementBoundingBoxEnabled = false;
	this.movementBoundingBox = new Box3();
	this.movementBoundingBoxHelper = new Box3Helper( this.movementBoundingBox );

	this.setMovementStrategy( "default" );

/*	this.light.refresh = (function( player ){
		this.position.copy( player.headPos );
		this.rotation.copy( this.camera.rotation )
	}).bind( this.light, this );*/

	(function( floor, player ) {
		floor.position.copy( player.pos );
		floor.visible = false;
		floor.setSize = (function(){
			var _size;
			return function( size, force ){
				if (_size != size && (_size = size)) {
					if (!force)_size = Math.max( _size, 0.1 );
					floor.geometry.copy(( new GridHelper( 100, 100/_size )).geometry );
				}
			};
		})();
		floor.refresh = function(){
			if (window.gameService.opts.game.lockToGrid == "world") floor.position.set( 0, player.pos.y, 0 );
			else floor.position.copy( player.pos );
		};
	})( this.floorObj = new GridHelper( 101, 101 ), this );
}

Player.prototype = Object.create( PlayerAsClass.prototype );
Player.prototype.constructor = Player;



Player.prototype.getOpts = function() {
	return {
		fov                   : this.opts.fov,
		fspeed                : this.opts.fspeed,
		cameraSlerp           : this.opts.cameraSlerp,
		disableGravity        : this.opts.disableGravity,
		disableWalls          : this.opts.disableWalls,
		disableVerticalCamera : this.opts.disableVerticalCamera,
		disableJumping        : this.opts.disableJumping,
		height                : this.height,
		footHeight            : this.footHeight
	};
};

Player.prototype.setCamera = function( key, lock ){
	if (!this.cameras[ key ]) return console.warn( "Camera not found" );
	this.camera = this.cameras[ key ];
	this.camera.userData.type = key;
	this.camera.userData.lock = lock || null;
	this.camera.zoom = 1;
	this.camera.updateProjectionMatrix();
	this.light.target = this.camera;

	this.setMovementStrategy( "default" );

	console.log( "Player camera changed to "+key, this.camera );

	return this.camera;
};
Player.prototype.setFov = function( fov ){
	if( fov != null ) this.camera.fov = this.opts.fov = fov;

	this.camera.aspect = window.windowHalfX / window.windowHalfY;
	this.update();
};
Player.prototype.update = (function(){

    var target_rot     = new Object3D();
    var target_rot_axX = new Vector3( 1, 0, 0 );
    var target_rot_axY = new Vector3( 0, 1, 0 );

	var prev_headPos = new Vector3();
	var prev_headRot = new Euler();

	var footRaycasterOpposite = new Raycaster();
	footRaycasterOpposite.ray.direction.set( 0, 1, 0 );

	var footRaycaster_N = 5;
	var footRaycaster_rad = 2 * Math.PI / footRaycaster_N;

	var playerLightDirVector = new Vector3( 0, 0, 0.5 );

	return function updatePlayer() {

		target_rot.rotation.set( 0, 0, 0 );

		var sideways = this.keys.left - this.keys.right;
		var forward  = this.keys.down - this.keys.up;

		/** m/s -> m/fps **/
		var fspeed = this.fspeed / gameService.FPS;

		if (this.camera.userData.type == "bird") {
			var camera = this.cameras.bird;

			if (this.camera.userData.lock == "horizontal") {
		        target_rot.rotateOnAxis( target_rot_axY, this.av );

				this.headPos.x -= -Math.sin(this.av) * fspeed * forward;
				this.headPos.z -= -Math.cos(this.av) * fspeed * forward;
								
				this.headPos.x -= Math.sin(this.av + window.HalfPI) * fspeed * sideways;
				this.headPos.z -= Math.cos(this.av + window.HalfPI) * fspeed * sideways;

			} else if (this.camera.userData.lock == "top") {
				target_rot.rotateOnAxis( target_rot_axX, -Math.PI/2 );

				this.headPos.z += (this.keys.down  - this.keys.up)   / this.camera.userData.zspeed;
				this.headPos.x += (this.keys.right - this.keys.left) / this.camera.userData.zspeed;
			} else {
		        target_rot.rotateOnAxis( target_rot_axY, this.av );
				target_rot.rotateOnAxis( target_rot_axX, this.ah );

				this.headPos.x -= -Math.sin(this.av) * fspeed * forward;
				this.headPos.z -= -Math.cos(this.av) * fspeed * forward;
								
				this.headPos.x -= Math.sin(this.av + window.HalfPI) * fspeed * sideways;
				this.headPos.z -= Math.cos(this.av + window.HalfPI) * fspeed * sideways;
			}

			this.headPos.y += (this.keys.pgup - this.keys.pgdown) / this.camera.userData.zspeed;

			camera.position.copy( camera.$origo.copy( this.headPos ));
			camera.rotation.copy( target_rot.rotation );
			camera.$direction.copy( camera.$origo );
			camera.translateZ( camera.near );
			camera.$direction.sub( camera.position ).normalize();
		} else {

			/** walker-modessa ja kameran ylösalas-katselun ollessa lukittuna,
			 * Liikutetaan hahmoa eteen tai taaksepäin vertikaalisuunnan mukaisesti ja nollataan ko. suunta
			 */
			/* if (this.movement_strategy == "walker" && this.opts.disableVerticalCamera && this.ah != 0) {
				// Halutaan estää ylösalas -katselu ja sensijaan liikutetaan näkymää hiirellä

				forward -= this.ah * 10;
				this.ah = 0;
			} */

			this.move( -forward, sideways );

			if (this.av_plus) {

				this.av += Math.min( 0.01, Math.max( -0.01, this.av_plus ));

				this.hasMoved = true;
			}

			// Tarkastetaan pgup ja pgdown erikseen lattiatarkastelusta jotta voidaan liikkua lattioiden läpi
			if (this.keys.pgup) {

				this.pos.y += this.yspeed

				this.hasMoved = true;

			} else if (this.keys.pgdown) {

				this.pos.y -= this.yspeed;

				this.hasMoved = true;

			} else if (!this.opts.disableGravity) {
				// Tarkastetaan ollaanko lattialla, vai pitäisikö nostaa pelaaja lattian tasolle/pudottaa painovoiman vetämänä 
				
				if (this.hasMoved || this.yplus != 0) {
					
					var hit = null;

					this.footRaycaster.ray.far = this.height;
					footRaycasterOpposite.ray.far = this.height;

					// Läpikäydään pisteitä this.radius-säteiseltä kehältä silmien ympäriltä 
					// for (var aplu = 2*Math.PI/5, a = 0; a < Math.PI * 2; a += aplu) {
					for (var a, _a = 0; _a < footRaycaster_N; _a++) {
						a = _a * footRaycaster_rad;

						// Sijoitetaan Raycasteri silmien korkeudelle ja this.radius'n etäisyydelle
						this.footRaycaster.ray.origin.set(
							this.pos.x + Math.cos(a) * this.radius,
							this.pos.y + this.height,
							this.pos.z + Math.sin(a) * this.radius
						);

						var first = this.footRaycaster.intersectObject( worldModel, true )[0];
						/****************************
						 * Kokeilu uuden alla olevan liian läheisen pisteen yläpuolisen korkeuden määrittämiseksi.
						 * Eli voidaanko pelaaja asettaa siihen vai pitääkö perua liikettä
						 */
						if (false && first && first.face) try {
							var rc = footRaycasterOpposite;
							rc.ray.origin.copy( first.point );
							var hits = rc.intersectObject( worldModel, true ).length;
							if (hits.length) console.log( "HEREIAM", hits );
						} catch(e) {/* console.error("HEREIAM", e);*/debugger;}
						/****************************/

						// Merkitään talteen kaikkein läheisin törmäyspiste
						if (first && first.face && (!hit || first.distance < hit.distance)) {
							hit = first;
						}
					}

					// Alla on piste
					if (hit) {
						if (hit.distance - this.height <= this.yplus) {
							// Ollaan riittävän lähellä, jotta voidaan todeta että ollaan lattialla
							this.pos.y    = hit.point.y;
							this.yplus    = 0;
							this.jumpable = true;
						} else {
							// Ollaan liian kaukana, joten ollaan vapaassa pudotuksessa
							this.pos.y   -= this.yplus;
							this.yplus   += this.g_yplus;
							this.jumpable = false;
						}
					}
				}
			}

			this.headPos.set( this.pos.x, this.pos.y + this.height, this.pos.z );

			target_rot.rotateOnAxis( target_rot_axY, this.av ).rotateOnAxis( target_rot_axX, this.ah );

//			this.camera.rotation.copy( target_rot.rotation );
    	    this.camera.quaternion.slerp( target_rot.quaternion, this.opts.cameraSlerp );
		

			this.obj.rotation.copy( this.camera.rotation );
			this.obj.position.set( this.pos.x, this.pos.y + this.height / 2, this.pos.z );

		}

		/*********/

		this.hasMoved = false;


		if (!this.hasMoved && !player.headPos.equals( prev_headPos )) this.hasMoved = true;
		
		prev_headPos.copy( player.headPos );


		if (!this.hasMoved && !player.camera.rotation.equals( prev_headRot )) this.hasMoved = true;

		prev_headRot.copy( player.camera.rotation );

		/*********/

		if (this.hasMoved) {

			this.light.position.copy( playerLightDirVector ).applyEuler( this.camera.rotation ).add( this.camera.position );
			this.light.lookAt( this.camera );

			this.floorObj.refresh();

			this.camera.updateProjectionMatrix();
		}
	};
})();


Player.movementUtils = {

	/** @type {(player: Player) => Object3D[]} */
	resolveHittableWalls: function( player ) {
		return [ worldModel, window.wallService.additional_walls_meshs ];
	},

	/** @type {(player: Player, movement: Vector3) => Vector3} */
	restrictMovementIntoBoundingBox: function( player, movement ) {
		if (player.movementBoundingBoxEnabled) {
			let restriced_movement =  movement.clone();
			if (restrictPositionIntoBoundingBox( player.movementBoundingBox, player.pos, restriced_movement )) {
				movement.set( restriced_movement.x, movement.y, restriced_movement.z );
			}
		}
		return movement;
	}
}

/**
 * Toteutetaan liike
 */
Player.prototype.move = (function() {

	var FRONT_HIT_RAYCASTER_MAX_ITERATIONS = 5;
	var FRONT_HIT_RAYCASTER_MIN_ITERATIONS = 1;
	var FRONT_HIT_RAYCASTER_MIN_STEP       = 0.05;
	var FRONT_HIT_RAYCASTER_MAX_TIME_MS    = 16;

	var frontRaycaster = new Raycaster();
	
	var movement = new Vector3();

	return function movePlayer( forward, sideways ) {

		forward  = forward  || 0;
		sideways = sideways || 0;

		if (!forward && !sideways) return;

		/** m/s -> m/fps **/
		var fspeed = this.fspeed / gameService.FPS;

		movement.x = -Math.sin(this.av) * fspeed * forward;
		movement.z = -Math.cos(this.av) * fspeed * forward;

		movement.x -= Math.sin(this.av + window.HalfPI) * fspeed * sideways;
		movement.z -= Math.cos(this.av + window.HalfPI) * fspeed * sideways;

		this.$$walkedTowardsWall = false;

		if (!this.opts.disableWalls) {
			var hit = null;

			/** Etäisyys jota lähemmäs ei seinää liikesuunnassa haluta päästä */
			var movlen = movement.length() * 2;

			/**
			 * Tutkitaan "hyväksyttävän" kynnyksen/portaan korkeudesta kameraan asti menosuuntaan.
			 * Jos törmätään johonkin, todetaan törmäyksen tapahtuneen
			 **/
			frontRaycaster.ray.direction.copy( movement ).normalize();
			frontRaycaster.far = movlen;

			/**
			 * Iteroidaan esteitä eteenpäin s.e.
			 * n. kierroksella käydään 1 / 2^N askeleen verran väliä [0, 1]
			 * Ja tarkastetaan itersectit ko. korkeudella JOS sitä ei olla läpikäyty aiemmin!
			 * 0. kierroksella käydään 1 / 2^0 askeleen verran väliä [0, 1] (0,1)            => ( 0.00, 1.00 ) => [x       x]
			 * 1. kierroksella käydään 1 / 2^1 askeleen verran väliä [0, 1] (0,.5,1)         => ( 0.50 )       => [    x    ]
			 * 2. kierroksella käydään 1 / 2^2 askeleen verran väliä [0, 1] (0,.25,.5,.75,1) => ( 0.25, 0.75 ) => [  x   x  ]
			 * 3. kierroksella käydään 1 / 2^3 askeleen verran väliä [0, 1]                                    => [ x x x x ]
			 */

			for (var checks={}, stime=Date.now(), iter=0; iter < FRONT_HIT_RAYCASTER_MAX_ITERATIONS; iter++) {

				var step = 1 / Math.pow( 2, iter );
				if (step < FRONT_HIT_RAYCASTER_MIN_STEP) break;

				for (var h = 0; h <= 1; h+=step) {

					if (!checks[h]) {
						checks[h] = true;

						var h_yplus = this.footHeight + (this.height - this.footHeight) * h;

						frontRaycaster.ray.origin.set( this.pos.x, this.pos.y + h_yplus, this.pos.z ).add( movement );

						const hittableObjects = Player.movementUtils.resolveHittableWalls( this );

						// Merkitään talteen kaikkein läheisin törmäyspiste
						var first = frontRaycaster.intersectObjects( hittableObjects, true )[0];
						if (first && first.face && ( !hit || first.distance < hit.distance )) {
							hit  = first;
						}
					}
				}

				// Jos iteroinnissa on kestänyt yli 100ms, skipataan
				//if (iter => FRONT_HIT_RAYCASTER_MIN_ITERATIONS && Date.now() - stime > FRONT_HIT_RAYCASTER_MAX_TIME_MS) {
				if (iter >= FRONT_HIT_RAYCASTER_MIN_ITERATIONS && Date.now() - stime > FRONT_HIT_RAYCASTER_MAX_TIME_MS) {
					break;
				}
			}

			// Osumia löydettiin
			if (hit) {
				var delta = movlen - hit.distance;

				/** Törmättiin seinään! */
				if (delta >= 0) {
					this.$$walkedTowardsWall = true;
					$rootScope.$broadcast( "player.$$walkedTowardsWall", this );

					/**
					 * Manipuloidaan liikettä törmäyksen seurauksena
					 */
					var hitManipulationStrategy = "backstep_tiny"
					switch (hitManipulationStrategy) {
						case "wall_slide":
							// Muutetaan liikesuunta seinän suuntaiseksi 
							
							var moment = movement.clone().normalize().multiplyScalar( hit.distance );
							var normal = hit.face.normal.clone();
							var dist   = moment.clone().negate().dot( normal );

							dist = Math.max( dist, 0.001 );
							var deltam = normal.clone().multiplyScalar( dist ).add( moment );

							movement = deltam;
							break;
						case "backstep":
							// Peräännytään otetun askeleen verran
							movement.negate();
							break;
						case "backstep_tiny":
							// Peräännytään otetun askeleen verran
							movement.negate().setLength( 0.01 );
							break;
						default:
							// Pysähdytään "kuin seinään"
							movement.set( 0, 0, 0 );
					}
				}
			}
		}

		if (movement.x !== 0 || movement.z !== 0 || movement.y !== 0) {
			movement = Player.movementUtils.restrictMovementIntoBoundingBox( this, movement );
		}

		if (movement.x !== 0 || movement.z !== 0 || movement.y !== 0) {

			this.hasMoved = true;

			this.pos.add( movement );

			this.floorObj.refresh();

			this.camera.updateProjectionMatrix();

		} else {

			// Ei liikuttu!
		}
	}
})();

Player.prototype.setMovementStrategy = (function() {
	var tmps = {};

	var strategies = {
		"default": {
			enable: function( player ) {

				setTimeout(() => {

					// Ollaanko yhtä samassa strategiassa?
					if (player.movement_strategy == "default") {

						// default-strategiassa täytyy saada liikkua, joten tehdään niin
						// Käytetään if-lauseketta, jotta mahdollinen setter ei laukea turhaan
						if (player.$keyboardControlsDisabled)   player.$keyboardControlsDisabled = false;
						if (player.$cameraControlsDisabled)     player.$cameraControlsDisabled = false;
					}
					
				}, 1000 );

			},
			disable: function( player ) {

			}
		},
		"walker": {
			enable: function( player ) {

				try {
					player.setCamera( 'head', null );
				} catch (error) { console.error( error ); }

				try {
					/** Piilotetaan erilaiset apuviivat */
					helpers.hideHelpers();
				} catch (error) { console.error( error ); }

				gameService.editor = false;

				gameService.setControlModeVisibility( false );

				try {
					window.entitySelectionService.unselectSelected();

					angular.element("body").injector().get("HUDService").refreshStateIndicator();

				} catch (error) { console.error(error); }

				tmps.prev = doGetValues( player );

				doSetValues({
					c_slerp:           0.5,
					p_fspeed:          1,
					d_gravity:         false,
					d_vertcam:         true,
					d_jumpable:        true,
					op_open:           false
				}, player );

			},
			disable: function( player ){
				doSetValues( tmps.prev, player );
				gameService.editor = true;
				tmps.prev = null;
			}
		}
	};

	return function( strategy ) {
		if (!strategies[ strategy ]) strategy = "default";

		try {
			if (this.movement_strategy) {
				if (typeof strategies[ this.movement_strategy ].disable == "function") {
					console.debug( "setMovementStrategy() :: strategies[" + this.movement_strategy + "].disable()" );
					strategies[ this.movement_strategy ].disable( this );
				}
				$( document.body ).removeClass( "playerMovementStrategy-" + this.movement_strategy );
			}

			if (typeof strategies[ strategy ].enable == "function") {
				console.debug( "setMovementStrategy() :: strategies["+strategy+"].enable()" );
				strategies[ strategy ].enable( this );
			}

			this.movement_strategy = strategy;

			$( document.body ).addClass( "playerMovementStrategy-" + this.movement_strategy );
		} catch (error) {
			console.error( error );
		}
	}


	function doSetValues( obj, player ) {
		if (typeof obj.c_slerp != "undefined") player.opts.cameraSlerp = obj.c_slerp;

		if (typeof obj.p_fspeed != "undefined") player.fspeed = obj.p_fspeed;

		if (typeof obj.d_gravity != "undefined") player.opts.disableGravity = !!obj.d_gravity;

		if (typeof obj.d_vertcam != "undefined") player.opts.disableVerticalCamera = !!obj.d_vertcam;

		if (typeof obj.d_jumpable != "undefined") player.disableJumping = !!obj.d_jumpable;
	
		if (typeof obj.op_open != "undefined") try {
			angular.element(document.getElementById("oeuvres-list")).scope().$parent.open = obj.op_open;
		} catch (error) { }
	}

	function doGetValues( player ) {
		var obj = {};

		obj.c_slerp = player.opts.cameraSlerp;

		obj.p_fspeed = player.fspeed;

		obj.d_gravity = !!player.opts.disableGravity;

		obj.d_vertcam = !!player.opts.disableVerticalCamera;

		obj.d_jumpable = !!player.opts.disableJumping;

		try {
			obj.op_open = angular.element( document.getElementById( "oeuvres-list" )).scope().$parent.open;
		} catch (error) { /*console.error( error );*/ }

		return obj;
	}
})();

Player.prototype.lookAt = (function(){
	var vec = new Vector3();
	return function( mesh ){
		vec.copy( mesh.position ).sub( this.headPos ).normalize();
		this.ah = vec.y;
		this.av = Math.atan2( -vec.x, -vec.z );
	};
})();

/**
 * Päivitetään pelaajan sijainti siten että pään sijainti (.headPos) asetetaan pään jalkojen sijainnin (.pos) perusteella)
 */
Player.prototype.setPos = function( position ) {

	if (position != null) this.pos.copy( position );

	this.headPos.copy( this.pos );
	this.headPos.y += this.height;
};

/**
 * Päivitetään pelaajan sijainti siten että jalkojen sijainti (.pos) asetetaan pään sijainnin (.headPos) perusteella)
 */
Player.prototype.setHeadPos = function( position ) {

	if (position != null) this.headPos.copy( position );

	this.pos.copy( this.headPos );
	this.pos.y -= this.height;
};


Player.prototype.adjustToFloor = function() {
	var intersects = getIntersects( this.headPos, new Vector3( 0, -1 )).filter(function( intr ){
		if (!intr.object) return false;
		if (!intr.face) return false;

		if( intr.object.userData.isSkybox ) return false;

		return true;
	});

	var floor = intersects[0];

	if (floor) {
		var deltaY = this.height - floor.distance;
		this.headPos.y += deltaY;
	}

	this.setHeadPos();
};

Player.prototype.adjustToLookPainting = function( oeuvre ){

	/**
	 * Lasketaan etäisyys siten, että suoraan edestä katsottuna 
	 * teoksen pystyssivusivu on tasan puolet näkökentästä
	 * (player.camera.fov = "Camera frustum vertical field of view, from bottom to top of view")
	 */

	// Halutaan "puolet" teoksen korkeudesta mitan ylä- ja alapuolelle, siis 2*h, mutta opposite on tästä puolet
	var opposite = oeuvre.h;

	// camera.fov on asteita
	var a = THREEMath.DEG2RAD * player.camera.fov / 2;

	// tan(a) = vastainen / viereinen
	var distance = opposite / Math.tan( a );

	// Etäisyys vähintään metri seinästä (pienet teokset)
	distance = Math.max( 1.0, distance );

	/** @TODO: min_distance on teoksesta katsottuna lähimmän objektin etäisyys */
	
	return this.adjustToLookMesh( oeuvre.mesh, distance );
};

Player.prototype.adjustToLookMesh = function( mesh, dist ){

	if (!mesh) return;

	let ignoreWalk = false;

	try {
	
		if (Spherical360SetupService.getInstance().enabled) ignoreWalk = true;
	
	} catch (error) {}

	if (!ignoreWalk) {

		if (!dist) try {
			/** @TODO: lasketaan dist siten että objekti täyttää puoliksi ruudun.
			 *  Työkaluina siis player.camera.fov sekä getBoundingSphere
			 */
			// esim. jotain jotain dist = (new THREE.Box3( ).setFromObject( mesh )).getBoundingSphere().radius;
		} catch (error) {
			console.error( error );
		} 

		// Selvitetään "Lattiansuuntainen" piste kohteesta haluttu matka 'dist' poispäin kohteesta kohteen "osoittamaan" suuntaan
		var delta = new Vector3( 0, 0, dist || 1 ).applyEuler( mesh.rotation );

		// Sijoitetaan pelaaja kohteen luo ..
		this.headPos.copy( mesh.position ).add( delta );

		// .. Ja varmistetaan, että ollaan lattialla
		this.adjustToFloor();

		console.log("Player.adjustToLookMesh :: mesh:", mesh, ", new pos:", this.headPos );
	}

	// Ja vielä halutaan myös katsoa objektia
	this.lookAt( mesh );
};

Player.prototype.walkToLookPainting = function( oeuvre ) {

    // Get the mesh from the oeuvre parameter
    var mesh = oeuvre.mesh;

	let ignoreWalk = false;

	try {
	
		if (Spherical360SetupService.getInstance().enabled) ignoreWalk = true;
	
	} catch (error) {}

	if (ignoreWalk) {
		
    	player.turnToLookMesh( oeuvre.mesh );

	} else {

		var opposite = oeuvre.h;

		// Convert the field of view of the camera from degrees to radians and divide it by 2
		var a = THREEMath.DEG2RAD * player.camera.fov / 2;

		// Calculate the distance to the mesh using the opposite side and the tangent of half the field of view angle
		var distance = Math.max( opposite / Math.tan( a ), 1.0 );

    	// Call the walkToLookMesh method of the player object with the mesh and distance parameters
    	player.walkToLookMesh( oeuvre.mesh, distance );
	}
}

Player.prototype.endWalkerView = function() { this.setMovementStrategy( "default" ); };
Player.prototype.initWalkerView = function(){ this.setMovementStrategy( "walker" ); };


Player.prototype.setFloorSize = (function(){
	var _size;
	return function( size, force ){
		if (_size != size && (_size = size)) {
			if (!force)_size = Math.max( _size, 0.1 );
			this.floorObj.geometry.copy(( new GridHelper( 100, 100/_size )).geometry );
		}
	};
})();

/**********************************************
 *
 *
 *
 */

import { InteractiveMovingHandlerGenerator } from './interactive-moving-handler-generator.js';
Player.InterativeMovingHandlerGenerator = InteractiveMovingHandlerGenerator;

function __InterativeMovingHandlerGenerator( walkPhaseStepsArr ) {

	var stepTimeout = 10; // millisekunteja iterattioiden välissä

	if (walkPhaseStepsArr.length < 3) console.warn( "INVALID walkPhaseStepsArr" );
	
	var doStartPhase = walkPhaseStepsArr[0]                              || doStartPhaseDefault;
	var doEndPhase   = walkPhaseStepsArr[ walkPhaseStepsArr.length - 1 ] || doEndPhaseDefault;

	var arr = walkPhaseStepsArr.slice( 1, walkPhaseStepsArr.length - 1 );

	var phase_n = 0, phase_i = 0;

	var original_values;

	return function iterativeMovingHandler( argv1, argv2, argv3 ) {
		
		phase_n = 0;
		phase_i = 0;

		try {
			if (player.iterativeMovingTimeout) {
				clearTimeout( player.iterativeMovingTimeout );
				player.iterativeMovingTimeout = null;
			}
		} catch (error) {
			console.error( error );
		}

		try {

			doStartPhase();

			iterator();

		} catch (error) {
			reject( error );
		}


		function resolve() {
			console.debug( "player.iterativeMovingHandler :: iterator().finally()" );

			doEndPhase();

			clearTimeout( player.iterativeMovingTimeout );
			player.iterativeMovingTimeout = null;
		}

		function reject( error ) {
			console.debug( "player.iterativeMovingHandler :: iterator().catch()" );
			console.error( "player.iterativeMovingHandler :: iterator().catch() :: error =", error );

			resolve();
		}

		function iterator() {

			try {

				if (!arr[ phase_n ]) {
					if (arr[ phase_n + 1 ]) {
						phase_n++;
						phase_i = 0;
					} else {
						throw "player.iterativeMovingHandler :: Current phase_n unknown, so is next. Aborting!";
					}
				}

				if (!arr[ phase_n ][ phase_i ]) {
					if (arr[ phase_n ][ phase_i + 1 ]) {
						phase_i++;
					} else {
						throw "player.iterativeMovingHandler :: Current phase_i unknown, so is next. Aborting!";
					}
				}

				// funktio palauttaa true, kun sen phase on valmis, siis kun ollaan valmiina siirtymään seuraavaan phaseen
				var ret = arr[ phase_n ][ phase_i ]( phase_i, argv1, argv2, argv3 );

				if (ret) console.debug( "player.iterativeMovingHandler :: iterator() :: Step function signaled that phase is ready!" );

				// Jos funktio on signaloitunut phasen olevan valmis TAI seuraavaa askelta ei löydy niin pyritään siirtymään seuraavaan phaseen
				if (ret || !arr[ phase_n ][ phase_i + 1 ]) {
					phase_n++;
					phase_i = 0;
					
					// Tarkastellaan, onko seuraavaa vaihetta olemassa ja jos ei, oletetaan että päästiin loppuun onnistuneesti!
					if (!arr[ phase_n ] || !arr[ phase_n ][ phase_i ]) return resolve();

				} else {
					// Muutoin jatketaan nykyistä phasea ja siirrytään seuraavaan askeleeseen
					
					phase_i++;
				}
			
				player.iterativeMovingTimeout = setTimeout( iterator, stepTimeout );

			} catch (error) {
				reject( error );
			}
		}
	}


	function doStartPhaseDefault() {

		original_values = {
			player_opts_disableGravity           : !!player.opts.disableGravity,
			player_opts_disableWalls             : !!player.opts.disableWalls,
			player_keyboard_controls_disabled    : !!player.$keyboardControlsDisabled,
			player_camera_controls_disabled      : !!player.$cameraControlsDisabled,
			player_camera_zoom_controls_disabled : !!player.$cameraZoomControlsDisabled
		};

		player.$keyboardControlsDisabled = true;
		player.$cameraControlsDisabled = true;
		player.$cameraZoomControlsDisabled = true;

		// Pitää ottaa pois käytöstä sillä update()'ssa ajettaessa muodostuu "tärinää" jos kohdeobjekti on kameraa ylempänä
		player.opts.disableGravity = true;
		
		// Poistetaan käytöstä koska tarkistus hidastaa askellusta eikä törmäsylaskentaa tarvita
		player.opts.disableWalls   = true;
	}

	function doEndPhaseDefault() {

		player.$keyboardControlsDisabled   = !!original_values.player_keyboard_controls_disabled;
		player.$cameraControlsDisabled     = !!original_values.player_camera_controls_disabled;
		player.$cameraZoomControlsDisabled = !!original_values.player_camera_zoom_controls_disabled;
		player.opts.disableGravity         = !!original_values.player_opts_disableGravity;
		player.opts.disableWalls           = !!original_values.player_opts_disableWalls;

		original_values = null;
	}
}


Player.prototype.walkToLookMesh = (function() {

	var doMovingArr = [];
	for (var i = 0; i < PLAYER_MAX_WALK_ITERATIONS; i++) doMovingArr.push( doMoving );

	// Taikaluvut
	var posLerpDelta_limit = 0.0005; // Nykyisen ja tavoitellun sijainnin etäisyyden hyväksyttävä alaraja. Metriä
	var rotLerpDelta_limit = 0.002;  // Nykyisen ja tavoitellun katseen suuntavektorin muutoksen eron hyväksyttävä alaraja. Radiaanien erotus
	var lerpAlpha          = 0.03 ;  // Prosenttia @see https://threejs.org/docs/?q=vector#api/en/math/Vector3.lerp

	// Scopen käyttämät muuttujat
	var posLerpDelta = null;
	var rotLerpDelta = null;

	var current_position = new Vector3();
	var target_position = new Vector3();
	var new_position = new Vector3();

	var current_rotation = new Vector2();
	var target_rotation = new Vector2();
	var new_rotation = new Vector2();

	var original_values = {};

	let radiansAngleDifference = ( angle1, angle2 ) => {
		let diff = angle2 - angle1;

		// If the difference is greater than PI, subtract 2*PI to get the smaller angle
		if (diff > Math.PI) {
			diff -= 2 * Math.PI;
		}

		// If the difference is less than -PI, add 2*PI to get the smaller angle
		if (diff < -Math.PI) {
			diff += 2 * Math.PI;
		}

		// Return the absolute value of the difference as the smallest angle
		return diff;
	};

	/**
	 */
	function doMoving( phase_i, mesh, distance ) {

		// Ensimmäisellä iteraatiokierroksella generoidaan haluttu lopputulos
		if (phase_i == 0) {

			var distance_delta = new Vector3( 0, 0, distance || 1 ).applyEuler( mesh.rotation );

			// Sijainti suoraan teoksen "edessä" 
			new_position.copy( mesh.position ).add( distance_delta );

			// Sijainti em. sijainnissa, mutta projisoituna "lattialle", pelaajan silmien korkeudelle
			adjustPointToHeight( new_position, player.height, new_position );

		}


		/** ALUSTETAAN NYKYTILA */
		current_position.copy( player.headPos );
		current_rotation.set( player.ah, player.av );

		/** PÄIVITETÄÄN SIJAINTI
		 * Lähestytään nykyisestä sijainnista kohti uutta sijaintia */
		current_position.lerp( new_position, lerpAlpha );

		/** PÄIVITETÄÄN KATSESUUNTA */
		// Katsesuunta
		var direction = new Vector3().copy( mesh.position ).sub( current_position ).normalize();

		let dir_ah = direction.y;
		let dir_av = Math.atan2( -direction.x, -direction.z )

		dir_ah = player.ah + radiansAngleDifference( player.ah, dir_ah ) * lerpAlpha;
		dir_av = player.av + radiansAngleDifference( player.av, dir_av ) * lerpAlpha;

		if (true) {
			/**
			 * Staattinen, jäykkä versio, jossa katsotaan koko ajan kohteeseen
			 */

			rotLerpDelta_limit = 0; // Nollataan, jottein rotLerpDelta ole aina true

			target_rotation.set( dir_ah, dir_av );
			
			new_rotation.copy( target_rotation );

		} else {
			/**
			 * Pehmeämpi versio, jossa ilmeni pyörähtämisongelma akselien ristetessä oikein
			 */

			if (dir_av < player.av) dir_av += 2 * Math.PI;

			target_rotation.set( dir_ah, dir_av );

			new_rotation.lerpVectors( current_rotation, target_rotation, lerpAlpha );

			if (new_rotation.y > Math.PI) new_rotation.y -= 2 * Math.PI;
		}

		/** TOTEUTETAAN UUSI SIJAINTI & KATSESUUNTA */

		player.headPos.copy( current_position );
		player.setHeadPos();

		player.ah = new_rotation.x;
		player.av = new_rotation.y;		



		/*******
		 * Selvitetään toteutuneen muutoksen suuruus
		 */
		
		// var _posLerpDelta = player.headPos.clone().normalize().cross( new_position.normalize()).length();
		var _posLerpDelta = current_position.distanceTo( new_position );
		
		var _rotLerpDelta = current_rotation.clone().normalize().cross( new_rotation.clone().normalize());
		//var _rotLerpDelta = target_rotation.clone().normalize().cross( new_rotation.clone().normalize());

		if (posLerpDelta != null && rotLerpDelta != null) {
			/*******
			 * Vertaillaan muutosvauhtia raja-arvoon s.e., tarpeeksi pienellä muutoksella (== lähellä oikeaa lopputulosta),
			 * välitetään tieto lopun läheisyydestä palautusarvolla.
			 */

			let posLerpDeltaDiff = posLerpDelta - _posLerpDelta;
			let rotLerpDeltaDiff = rotLerpDelta - _rotLerpDelta;

			let posLerpDeltaDiffAbs = Math.abs( posLerpDeltaDiff );
			let rotLerpDeltaDiffAbs = Math.abs( rotLerpDeltaDiff );

			let posOnChange = posLerpDeltaDiffAbs < posLerpDelta_limit;
			let rotOnChange = rotLerpDeltaDiffAbs < rotLerpDelta_limit;

			if (posOnChange) {
				console.debug( "player.walkToLookMesh :: doMoving() :: |posLerpDelta - _posLerpDelta| < posLerpDelta_limit (" + posLerpDeltaDiff + " < "+posLerpDelta_limit+")m" );
			}

			if (rotOnChange) {
				console.debug( "player.walkToLookMesh :: doMoving() :: |rotLerpDelta - _rotLerpDelta| < rotLerpDelta_limit (" + rotLerpDeltaDiff + " < " + rotLerpDelta_limit + ")rad" );
			}

			if (posOnChange && rotOnChange) {
				return true;
			}
		}

		posLerpDelta = _posLerpDelta;
		rotLerpDelta = _rotLerpDelta;
	}

	return Player.InterativeMovingHandlerGenerator([ null, doMovingArr, null ]);
})();


Player.prototype.turnToLookMesh = (function() {

	var doTurningArr = [];
	for (var i = 0; i < PLAYER_MAX_TURN_ITERATIONS; i++) doTurningArr.push( doTurning );

	// Taikaluvut
	var lerpAlpha = 0.03;

	let radiansAngleDifference = ( angle1, angle2 ) => {
		let diff = angle2 - angle1;

		// If the difference is greater than PI, subtract 2*PI to get the smaller angle
		if (diff > Math.PI) {
			diff -= 2 * Math.PI;
		}

		// If the difference is less than -PI, add 2*PI to get the smaller angle
		if (diff < -Math.PI) {
			diff += 2 * Math.PI;
		}

		// Return the absolute value of the difference as the smallest angle
		return diff;
	};

	var direction = new Vector3();
	var dir_ah, dir_av;

	/**
	 */
	function doTurning( phase_i, mesh, distance ) {

		// Ensimmäisellä iteraatiokierroksella generoidaan haluttu lopputulos
		if (phase_i == 0) {

			direction.copy( mesh.position ).sub( player.headPos ).normalize();

			dir_ah = direction.y;
			dir_av = Math.atan2( -direction.x, -direction.z );
		}

		player.ah = player.ah + radiansAngleDifference( player.ah, dir_ah ) * lerpAlpha;
		player.av = player.av + radiansAngleDifference( player.av, dir_av ) * lerpAlpha;
	}

	return Player.InterativeMovingHandlerGenerator([ null, doTurningArr, null ]);
})();

Player.prototype.walkToPosition = (function() {

	var doMovingArr = new Array( PLAYER_MAX_WALK_ITERATIONS ).fill( null ).map(function(){ return doMoving });

	// Taikaluvut
	var posLerpDelta_limit = 0.01; // Nykyisen ja tavoitellun sijainnin etäisyyden hyväksyttävä alaraja. Metriä
	var lerpAlpha          = 0.03; // Prosenttia @see https://threejs.org/docs/?q=vector#api/en/math/Vector3.lerp

	// Scopen käyttämät muuttujat
	var posLerpDelta = null;

	var current_position = new Vector3();
	var target_position = new Vector3();
	var new_position = new Vector3();


	var original_values = {};

	/**
	 */
	function doMoving( phase_i, new_position ) {

		/** ALUSTETAAN NYKYTILA */
		current_position.copy( player.headPos );

		/** PÄIVITETÄÄN SIJAINTI
		 * Lähestytään nykyisestä sijainnista kohti uutta sijaintia */
		current_position.lerp( new_position, lerpAlpha );

		/** TOTEUTETAAN UUSI SIJAINTI & KATSESUUNTA */

		player.headPos.copy( current_position );
		player.setHeadPos();


		// var _posLerpDelta = player.headPos.clone().normalize().cross( new_position.normalize()).length();
		var _posLerpDelta = current_position.distanceTo( new_position );

		if (Math.abs(posLerpDelta - _posLerpDelta) < posLerpDelta_limit) {
			console.debug( "player.walkToLookMesh :: doMoving() :: posLerpDelta - _posLerpDelta < posLerpDelta_limit ("+(posLerpDelta-_posLerpDelta)+" < "+posLerpDelta_limit+")m" );
			return true;
		}

		posLerpDelta = _posLerpDelta;
	}

	return Player.InterativeMovingHandlerGenerator([ null, [function() { player.$cameraControlsDisabled = false; }], doMovingArr, null ]);
})();

export { adjustPointToHeight };
